<template>
    <div class="nouvelle-single-wrapper pb-5">
        <div class="hero-background eggshell"></div>

        <header class="header-single-news" page-transition-group>
            <HeroNewsSingle v-if="contentIsLoaded" />
        </header>

        <main class="page-content" page-transition-group>
            <article v-if="contentIsLoaded && content.matrixSections.sections">

                <MatrixFields
                    v-for="(element, index) in content.matrixSections.sections"
                    :key="'blog-section-' + index"
                    :matrix="element"
                />
                <div
                    v-if="contentIsLoaded && content.blogSwipper.swipper.length"
                    class="swiper-news-wrapper blog"
                >
                    <SwiperNews :imgGallery="content.blogSwipper" />
                </div>
            </article>
        </main>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapActions } from 'vuex'
import HeroNewsSingle from '@/components/hero/HeroNewsSingle.vue'
import SwiperNews from '@/components/swiper/SwiperNews'
// import AssetLoader from '@/components/helpers/AssetLoader'

import MatrixFields from '@/components/matrix/matrixFields'

export default {
    name: 'Nouvelle',

    metaInfo() {
        return {
            ...(this.content && this.content.title && { title: this.content.title.replace(/&nbsp;/g, ' ') }),
            ...(this.content && this.content.title &&  { titleTemplate: this.content.title.replace(/&nbsp;/g, ' ') }),

            meta: [
                {
                    vmid: 'og:title',
                    property: 'og:title',
                    content: this.contentIsLoaded ? this.content.title.replace('&nbsp;', ' ') : '',
                },

                {
                    vmid: 'description',
                    name: 'description',
                    content: this.contentIsLoaded ? this.content.newsExerpt : '',
                },
                {
                    vmid: 'og:description',
                    property: 'og:description',
                    content: this.contentIsLoaded ? this.content.newsExerpt : '',
                },
                {
                    vmid: 'og:image',
                    property: 'og:image',
                    content: this.contentIsLoaded ? this.content.featuredImage.img.url : '',
                },
                {
                    vmid: 'twitter:image',
                    name: 'twitter:image',
                    content: this.contentIsLoaded ? this.content.featuredImage.img.url : '',
                },
                {
                    vmid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.contentIsLoaded ? this.content.title.replace(/&nbsp;/g, ' ') : '',
                },
                {
                    vmid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.contentIsLoaded ? this.content.newsExerpt : '',
                },
            ],
        }
    },

    components: {
        // AssetLoader,
        HeroNewsSingle,
        SwiperNews,
        MatrixFields,
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },

    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
}
</script>

<style lang="scss"></style>
